import React from "react";

const ChartState = ({ loading, empty, children }) => {
  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 320 }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (empty) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-secondary"
        style={{ minHeight: 320 }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-chart-bar-popular">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -6" />
          <path d="M9 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -10" />
          <path d="M15 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -14" />
          <path d="M4 20h14" />
        </svg>
        <div className="mt-2">Belum ada data pada periode ini.</div>
      </div>
    );
  }

  return children;
};

export default ChartState;
